import type { PageProps, PayallStoryPageProps } from "@/types";
import React, { FC } from "react";
import {
  PayallStoryCrossBorderInfrastructure,
  PayallStoryGallery,
  PayallStoryHero,
  PayallStoryTheSolution,
} from "../payall-story";
import { NextPage } from "../next-page";
import Head from "next/head";

export const PayallStory: FC<PageProps<PayallStoryPageProps>> = (props) => {
  return (
    <>
    <Head>
      <meta property="og:title" content={props.data.title} />
      <meta property="og:image" content={props.data.cover.file?.url ?? ''} />
    </Head>
    <div>
      <PayallStoryHero
        label={props.meta.translation.payallStory.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <PayallStoryTheSolution {...props.data.theSolution} />
      <PayallStoryCrossBorderInfrastructure
        content={props.data.crossBorderInfrastructure}
        worldTitle={
          props.meta.translation.payallStory.crossBorderInfrastructure
            .worldTitle
        }
        worldCoverage={props.data.worldCoverage}
      />
      <PayallStoryGallery gallery={props.data.gallery} />
      <NextPage {...props.data.nextPage} />
    </div>
    </>
  );
};
